// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"f4144c7e","143":"4a056fa9","348":"63ee99c1","381":"420eac07","494":"8b1a86cd","682":"69ec1c63","852":"5e0f8a2a","883":"1679615f","940":"ee4f2fd7"}[chunkId] + ".chunk.js";
};